export enum RadioTextFilterOperation {
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  NOT_STARTS_WITH = 'NOT_STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  NOT_ENDS_WITH = 'NOT_ENDS_WITH',
  IS = 'IS',
  IS_NOT = 'IS_NOT',
  IS_EXACTLY = 'IS_EXACTLY',
  IS_NOT_EXACTLY = 'IS_NOT_EXACTLY',
  IS_UNKNOWN = 'IS_UNKNOWN',
  HAS_ANY_VALUE = 'HAS_ANY_VALUE',
  REGEX = 'REGEX',
}

export const RadioTextFilterOperationsWithoutSpecificValue = [
  RadioTextFilterOperation.IS_UNKNOWN,
  RadioTextFilterOperation.HAS_ANY_VALUE,
];

// We need to create all the types for typescript to be able to infer the type based on the operation property.

export interface ContainOperation {
  operation: RadioTextFilterOperation.CONTAINS;
  value: string;
}

export interface NotContainOperation {
  operation: RadioTextFilterOperation.NOT_CONTAINS;
  value: string;
}

export interface StartWithOperation {
  operation: RadioTextFilterOperation.STARTS_WITH;
  value: string;
}

export interface NotStartWithOperation {
  operation: RadioTextFilterOperation.NOT_STARTS_WITH;
  value: string;
}

export interface EndWithOperation {
  operation: RadioTextFilterOperation.ENDS_WITH;
  value: string;
}

export interface NotEndWithOperation {
  operation: RadioTextFilterOperation.NOT_ENDS_WITH;
  value: string;
}

export interface IsOperation {
  operation: RadioTextFilterOperation.IS;
  value: string;
}

export interface IsNotOperation {
  operation: RadioTextFilterOperation.IS_NOT;
  value: string;
}

export interface IsExactlyOperation {
  operation: RadioTextFilterOperation.IS_EXACTLY;
  value: string;
}

export interface IsNotExactlyOperation {
  operation: RadioTextFilterOperation.IS_NOT_EXACTLY;
  value: string;
}

export interface IsUnknownOperation {
  operation: RadioTextFilterOperation.IS_UNKNOWN;
}

export interface HasAnyValueOperation {
  operation: RadioTextFilterOperation.HAS_ANY_VALUE;
}

export interface MatchesRegExOperation {
  operation: RadioTextFilterOperation.REGEX;
  value: string;
}

export type RadioTextFilterValue =
  | ContainOperation
  | NotContainOperation
  | StartWithOperation
  | NotStartWithOperation
  | EndWithOperation
  | NotEndWithOperation
  | IsOperation
  | IsNotOperation
  | IsExactlyOperation
  | IsNotExactlyOperation
  | IsUnknownOperation
  | HasAnyValueOperation
  | MatchesRegExOperation;

export type RadioTextFilterValueType = RadioTextFilterValue | undefined;

export type DropdownStyle = 'withRadio' | 'withSelect';

export enum ValidationErrorEnum {
  SELECT_ONE_OPTION = 'Select an option',
  TEXT_TOO_SHORT = 'Text is too short',
  TEXT_EMPTY = 'Text is empty',
}

export const readableRadioTextOperations: Record<RadioTextFilterOperation, string> = {
  [RadioTextFilterOperation.CONTAINS]: 'contains',
  [RadioTextFilterOperation.NOT_CONTAINS]: 'does not contain',
  [RadioTextFilterOperation.STARTS_WITH]: 'starts with',
  [RadioTextFilterOperation.NOT_STARTS_WITH]: 'does not start with',
  [RadioTextFilterOperation.ENDS_WITH]: 'ends with',
  [RadioTextFilterOperation.NOT_ENDS_WITH]: 'does not end with',
  [RadioTextFilterOperation.IS]: 'is',
  [RadioTextFilterOperation.IS_NOT]: 'is not',
  [RadioTextFilterOperation.IS_UNKNOWN]: 'is unknown',
  [RadioTextFilterOperation.HAS_ANY_VALUE]: 'has any value',
  [RadioTextFilterOperation.REGEX]: 'matches regex',
  [RadioTextFilterOperation.IS_EXACTLY]: 'is exactly',
  [RadioTextFilterOperation.IS_NOT_EXACTLY]: 'is not exactly',
};
